import { Component, Input, OnInit } from '@angular/core';
import { KamonaOtpWidgetComponent } from '../../kamona-otp-widget.component';

@Component({
    selector: 'app-mobile-kamona-otp-widget',
    templateUrl: './mobile-kamona-otp-widget.component.html',
    styleUrls: ['./mobile-kamona-otp-widget.component.scss'],
})
export class MobileKamonaOtpWidgetComponent extends KamonaOtpWidgetComponent implements OnInit {
    @Input() useHeaderBorder = false;
    @Input() headerTitle: string;

    ngOnInit(): void {
        this.initialize();
    }
}
